import { Box, Stack, Typography } from "@mui/material";
import { keyframes } from "@mui/system";

const pulse = keyframes`
  0% {
    transform: scale(1);
  }

  5% {
    transform: scale(1.02);
  }

  10% {
    transform: scale(1);
  }

  15% {
    transform: scale(1.02);
  }

  20% {
    transform: scale(1);
  }

  /* pause */
  100% {
    transform: scale(1);
  }
`;

const ComponentPenunjang = ({
  image,
  title,
  click,
}: {
  image: string;
  progress?: number;
  is_done?: boolean;
  title?: string;
  label?: string;
  jumlah_tunggu?: number;
  nomor?: number;
  click: Function;
}) => {
  const body = {
    backgroundImage: `url(${image})`,
    borderRadius: "16px",
    height: "100%",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  };

  const ImageBackground = () => {
    return (
      <>
        <Box
          sx={{
            ...body,
            position: "absolute",
            zIndex: 2,
            left: 0,
            right: 0,
            bottom: 0,
            clipPath: `inset(0 0 100% 0)`,
            filter: "grayscale(100%)",
          }}
        ></Box>

        <Box
          sx={{
            ...body,
            position: "relative",
          }}
        ></Box>
      </>
    );
  };

  const ProgressText = () => {
    return (
      <Box
        position={"absolute"}
        bottom={0}
        left={0}
        right={0}
        display="flex"
        alignItems="baseline"
        justifyContent="center"
        zIndex={3}
        sx={{
          paddingTop: "4px",
          backgroundColor: "#FFF",
          borderRadius: "16px",
        }}
      >
        <Stack spacing={0} alignItems="center">
          <Typography variant="body1" fontWeight="" textAlign="center">
            {title}
          </Typography>
        </Stack>
      </Box>
    );
  };

  return (
    <>
      <Box
        sx={{
          position: "relative",
          height: "200px",
          animation: `${pulse} 6s ease-in-out 4`,
        }}
        onClick={() => click()}
      >
        <>
          <ImageBackground />
          <ProgressText />
        </>
      </Box>
    </>
  );
};

export default ComponentPenunjang;
